import { render, staticRenderFns } from "./FilterProducts.vue?vue&type=template&id=38fa789a&scoped=true&"
import script from "./FilterProducts.vue?vue&type=script&lang=js&"
export * from "./FilterProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa789a",
  null
  
)

export default component.exports